export function formatAddress(address: Record<string, unknown> = {}) {
  if (typeof address !== 'object' || address === null)
    return ''

  return [address.streetLine1, address.streetLine2, address.postalCode, address.city, address.province, address.country].filter(Boolean).join(', ')
}
